import React, { Component } from "react";
import BangerText from './components/bangerText';
import FeaturedCompanies from './components/featuredCompanies';
import Hero from './components/hero';
import Footer from "./components/footer";
import ParallaxCollage1 from "./components/parallaxCollage1";
import ScrollHighlightText from "./components/scrollHighlightText";
import  './utils/analytics';

export default class Home extends Component {

  render() {
    return (
		<div>
			<Hero
				subtitle="Alpine Design"
				title={['Crafting Impressions',<br />, 'That Last']}
				backgroundImage="images/home-back.jpg"
				height="full"
			/>
			<div className="white-background tiny-padding">
				<BangerText
					text="An interactive design agency focused on exceptional design, superior quality, and continuous innovation"
				/>
				<div className="max-width-container">
					<FeaturedCompanies />
				</div>
				<div className="hide-for-small">
          <div className="max-width-container small-padding">
  					<ParallaxCollage1
  						image1="/images/parallax-home-image-1.png"
  						image2="/images/parallax-home-image-2.jpg"
  						backgroundImage="/images/parallax-home-background.jpg"
  						title="Ready to start your next project?"
  						description={['Web Design/Development',<br />,'UI/UX Design/Development',<br />,'Design Services',<br />,'Logo Identity',<br />,'Photography',<br />, 'Video Editing/Motion Graphics']}
  						cta="Get Started"
  						link="/contact"
  					/>
          </div>
        </div>
				<div className="show-for-small centered-text large-padding">
				  <h2>{'We provide our clients with'}</h2>
					<ScrollHighlightText
						list={['Web Design','UI UX Design','Web & App Development','Design Services','Logo Identity','Photography','Video Editing','Motion Graphics']}
					/>
					<br />
					<br />
				</div>
    	</div>
			<Footer />
		</div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/home.js